import styled, { css } from 'styled-components';

interface RadioOptionProps {
  isSelected: boolean;
}

export const RadioInput = styled.button.attrs({
  type: 'button',
})<RadioOptionProps>`
  display: flex;
  align-items: center;
  background: none;

  padding: 0 1.7rem;
  margin-bottom: 0.6rem;

  .radio {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.2rem;
    height: 2.2rem;
    border: 1px solid #000;
    border-radius: 50%;

    background: transparent;

    margin-right: 0.5rem;

    transition: ${({ theme }) => theme.transition.default};

    .filled {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: inherit;

      background: ${({ isSelected }) => (isSelected ? '#000' : '#fff')};
    }
  }

  > p {
    color: #000;
    transition: ${({ theme }) => theme.transition.default};
  }

  &:hover {
    .radio {
      border-color: #000;
    }

    > p {
      color: #000;
    }
  }
`;

export const FieldSet = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: column;
  width: 100%;

  margin-bottom: 2.6rem;

  div {
    border-radius: 2rem;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
`;

type FieldTitleProps = {
  secondary?: boolean;
};

export const FieldTitle = styled.span<FieldTitleProps>`
  font-size: 2.1rem;
  font-weight: bold;

  margin-bottom: 1.6rem;

  ${(props) =>
    props.secondary &&
    css`
      font-size: 1.8rem;
      padding: 0 1.9rem;

      margin-bottom: 0.5rem;
    `}
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;

  h1 {
    margin-bottom: 2rem;
  }

  .profile-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .sheet-model {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h3 {
      color: #00000080;
    }
  }
`;

export const RedirectModalContainer = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    text-transform: uppercase;
    margin-bottom: 2rem;
  }

  div {
    font-size: 2rem;
    padding-bottom: 3rem;
  }

  button {
    width: 60%;
  }
`;

export const DuplicateProgramContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 2rem;

  height: 100%;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    width: 100%;

    button {
      width: 40%;
    }
  }
`;

export const DuplicateProgramBtn = styled.button`
  width: 100%;
  background-color: white;
  border: 1px solid #707070;
  border-radius: 16px;
  margin-bottom: 2rem;
  padding: 0.5rem 0;

  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  gap: 1rem;
`;
